<div class="loading" *ngIf="loading">
    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
</div>